
export default {
    name: 'manage-view',
    components: {},
    props: {
        operation_tresorerie: {
            type: Object,
            default: () => {}
        },
        view_toggler: {
            type: Number,
            default: 0
        },
        solde_banque: {
            type: Object,
            default: () => {}
        }
    },

    watch: {
        view_toggler() {
            this.filename = ''
            this.is_loading = true
            this.file_is_empty = false

            if (this.operation_tresorerie.preuve == '' || this.operation_tresorerie.preuve == null) {
                this.file_is_empty = true
                this.is_loading = false
                return;
            }

            this.can_preview = this.checkIfCanPreview()

            this.asset_url = this.assets_path + '/files/preuves/'
            this.filename = this.asset_url+this.operation_tresorerie.preuve


            setTimeout(() => {
                this.is_loading = false
            }, 1000);
        }
    },

    data() {
        return {
            asset_url: '',
            filename: '',
            is_loading: true,
            file_is_empty: false,
            can_preview: true
        }
    },

    computed: {
        /**
         * Détail des coupures comptées lors du versement, reconstitué à partir
         * des tokens stockés dans 'versement_controle' (ex: "b-5-1000-secondaire")
         */
        recap_controle_lignes() {
            const brut = this.operation_tresorerie && this.operation_tresorerie.versement_controle;

            if (!brut) {
                return [];
            }

            let tokens = [];
            try {
                tokens = JSON.parse(brut);
            } catch (e) {
                return [];
            }

            if (!Array.isArray(tokens)) {
                return [];
            }

            const lignes = [];
            tokens.forEach(token => {
                const parts = ('' + token).split('-');
                const prefix = parts[0];
                const nb = parseFloat(parts[1]) || 0;
                const valeur = parseFloat(parts[2]) || 0;
                const role = parts[3] || '';

                if (nb > 0) {
                    lignes.push({
                        type_label: (prefix === 'p') ? 'Pièce' : 'Billet',
                        valeur,
                        nb,
                        sous_total: nb * valeur,
                        role,
                        sigle: (role === 'secondaire') ? this.currency_info.secondary_currency : this.currency_info.principal_currency
                    });
                }
            });

            return lignes;
        },

        /**
         * Totaux du contrôle des espèces, par devise (sommes brutes, non converties)
         */
        total_controle_principale() {
            return this.recap_controle_lignes
                .filter(ligne => ligne.role !== 'secondaire')
                .reduce((total, ligne) => total + ligne.sous_total, 0);
        },

        total_controle_secondaire() {
            return this.recap_controle_lignes
                .filter(ligne => ligne.role === 'secondaire')
                .reduce((total, ligne) => total + ligne.sous_total, 0);
        },

        /**
         * Total global du contrôle, converti en devise principale
         * (devise secondaire x taux, comme sur le contrôle des espèces), pour
         * affichage en pied du détail
         */
        total_controle_converti() {
            const rate = parseFloat(this.currency_info.rate) || 0;
            return this.total_controle_principale + (this.total_controle_secondaire * rate);
        },

        /**
         * Équivalent du total global, exprimé en devise secondaire
         */
        total_controle_converti_secondaire() {
            const rate = parseFloat(this.currency_info.rate) || 0;

            if (rate <= 0) {
                return 0;
            }

            return this.total_controle_converti / rate;
        }
    },

    mounted() {

    },

    methods: {
        checkIfCanPreview() {
            const filename = this.operation_tresorerie.preuve
            let can_view = false

            if (filename != '') {
                if (
                    filename.includes('pdf') || filename.includes('png') || 
                    filename.includes('PNG') || filename.includes('jpeg') || filename.includes('JPEG') || 
                    filename.includes('jpg') || filename.includes('JPG') 
                ) {
                    can_view = true
                }
            }
            return can_view
        }
    }
}


